import React from "react";
import { getHeadcountBridge } from "../orgDesignTreeEngine";
import { BridgeRowStyled, CardStyled, NumStyled, LabelStyled, SubStyled, OpStyled } from "./OrgDesignSummaryBridge.styles";

// Current FTEs − Reductions + Additions = Net Positions. Used by the
// workspace Summary tab and the PAIC import preview.
const OrgDesignSummaryBridge = ({ stats, statusCounts }) => {
  if (!stats) return null;

  const { currentFtes, reductions, additions, decreasedRoles, addedRoles, netPositions } = getHeadcountBridge(stats, statusCounts);

  return (
    <BridgeRowStyled>
      <CardStyled>
        <NumStyled>{currentFtes}</NumStyled>
        <LabelStyled>Current FTEs</LabelStyled>
      </CardStyled>
      <OpStyled>−</OpStyled>
      <CardStyled>
        <NumStyled $color="#ea580c">{reductions}</NumStyled>
        <LabelStyled>
          Reductions
          <SubStyled>from {decreasedRoles} role(s)</SubStyled>
        </LabelStyled>
      </CardStyled>
      <OpStyled>+</OpStyled>
      <CardStyled>
        <NumStyled $color="#16a34a">{additions}</NumStyled>
        <LabelStyled>
          Additions
          <SubStyled>from {addedRoles} role(s)</SubStyled>
        </LabelStyled>
      </CardStyled>
      <OpStyled>=</OpStyled>
      <CardStyled $bg="#eff6ff">
        <NumStyled $color="#0155e7">{netPositions}</NumStyled>
        <LabelStyled>Net Positions</LabelStyled>
      </CardStyled>
    </BridgeRowStyled>
  );
};

export default OrgDesignSummaryBridge;
